var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "merchant"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('reports.stockEnquiryReportHeader')))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showSelectMerchant) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "height": "32px",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "options": _vm.merchantList,
      "placeholder": _vm.$t('common.merchantPlaceholder'),
      "selected-option": _vm.selectedmerchant
    },
    on: {
      "select": _vm.selectMerchant
    },
    model: {
      value: (_vm.merchant),
      callback: function($$v) {
        _vm.merchant = $$v
      },
      expression: "merchant"
    }
  })], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.productID'))), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('productid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.productIdError'),
      "name": "productid",
      "id": "productid"
    },
    model: {
      value: (_vm.productid),
      callback: function($$v) {
        _vm.productid = $$v
      },
      expression: "productid"
    }
  })], 1), _vm._v(" "), (_vm.productid == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.IDerrors))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.stockTypeField')) + " "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stocktype),
      expression: "stocktype"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "stocktype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.stocktype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.stockType')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Accept"
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Reject"
    }
  }, [_vm._v("Reject")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "notinpo"
    }
  }, [_vm._v("Not In PO")])])]), _vm._v(" "), (_vm.stocktype == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.stocktypeErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.mrp')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-money'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('mrp')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('printProductDetails.mrpPH'),
      "name": "mrp",
      "id": "mrp"
    },
    model: {
      value: (_vm.mrp),
      callback: function($$v) {
        _vm.mrp = $$v
      },
      expression: "mrp"
    }
  })], 1), _vm._v(" "), (_vm.flag == true) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.MRPErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('grcList.lotNo')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-ticket'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('lotno')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('grcList.LotNoPlaceHolder'),
      "name": "lotno",
      "id": "lotno"
    },
    model: {
      value: (_vm.lotno),
      callback: function($$v) {
        _vm.lotno = $$v
      },
      expression: "lotno"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.rackID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-cubes'></i>"
    }
  }, [_c('b-form-input', {
    class: {
      'form-control': true,
      'error': _vm.errors.has('rackid')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.rackIDPlaceholder'),
      "name": "rackid",
      "id": "rackid"
    },
    model: {
      value: (_vm.rackid),
      callback: function($$v) {
        _vm.rackid = $$v
      },
      expression: "rackid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('warehouseRacks.subinventory')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subinventory),
      expression: "subinventory"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "client"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.subinventory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('reports.selectSubInventory')))]), _vm._v(" "), _vm._l((_vm.listsubinventoryData), function(client_obj) {
    return _c('option', {
      domProps: {
        "value": client_obj.inventoryname
      }
    }, [_vm._v(_vm._s(client_obj.inventoryname))])
  })], 2)])], 1), _vm._v(" "), (_vm.isInventoryZone == true) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.zoneName')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zonename),
      expression: "zonename"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "zonename"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.zonename = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.zoneName')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B2C"
    }
  }, [_vm._v("B2C")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B2B"
    }
  }, [_vm._v("B2B")])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-actions",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.SearchProduct(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v("\n             "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFlt
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("  " + _vm._s(_vm.$t('common.resetBtn')))]), _vm._v(" "), _c('br'), (_vm.stockerrors) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.stockerrors))]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isfoundID) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: " col-md-3 card-actions"
  }), _vm._v(" "), _c('div', {
    staticClass: " col-md-6 card-actions"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.table.heading')) + " -   " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 cardlistheader"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listData.length > 0) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('printProductDetails.download')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    attrs: {
      "disabled": _vm.isLoading,
      "title": "Download CSV"
    },
    on: {
      "click": function($event) {
        _vm.SearchProduct(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('download-excel', {
    staticClass: "btn btn-info downloadbutton ",
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "data": _vm.listStockReportDataforxls,
      "header": _vm.dataFilter2,
      "fields": _vm.csvFieldsForXls,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isfoundID) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.eanCode')) + " :")]), _vm._v(" " + _vm._s(_vm.listData[0].eancode))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.productId')) + " :")]), _vm._v(" " + _vm._s(_vm.listData[0].productid))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.totalCurrentStock')) + " :")]), _vm._v(" " + _vm._s(_vm.totalCurrentStock))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.totalRackStock')) + " :")]), _vm._v(" " + _vm._s(_vm.totalRackStock))])]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tableheader table-bordered text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.rackID')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader table-bordered text-center"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.mrp')))]), _vm._v(" "), (_vm.activemrpflag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('common.activemrp')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "tableheader table-bordered text-center"
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.currentStock')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader table-bordered text-center"
  }, [_vm._v(_vm._s(_vm.$t('reports.rackStock')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader table-bordered text-center"
  }, [_vm._v(_vm._s(_vm.$t('reports.rackStockAndCurrentStock')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader table-bordered text-center"
  }, [_vm._v(_vm._s(_vm.$t('grcList.lotNo')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader table-bordered text-center"
  }, [_vm._v(_vm._s(_vm.$t('printProductDetails.expiryDate')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader table-bordered text-center"
  }, [_vm._v(_vm._s(_vm.$t('reports.inventory')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader table-bordered text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.merchant')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader table-bordered text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.stockTypeField')))]), _vm._v(" "), (_vm.isInventoryZone == true) ? _c('th', {
    staticClass: "tableheader table-bordered text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.zoneName')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listData), function(eachItem) {
    return _c('tr', [_c('td', {
      staticClass: "table-bordered text-center"
    }, [_vm._v(_vm._s(eachItem.rackid))]), _vm._v(" "), _c('td', {
      staticClass: "table-bordered text-center"
    }, [_vm._v(_vm._s(eachItem.mrp))]), _vm._v(" "), (_vm.activemrpflag) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(eachItem.activemrp))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "table-bordered text-center"
    }, [_vm._v(_vm._s(eachItem.whcurrentstock))]), _vm._v(" "), _c('td', {
      staticClass: "table-bordered text-center"
    }, [_vm._v(_vm._s(eachItem.whrackstock))]), _vm._v(" "), (eachItem.whrackstock - eachItem.whcurrentstock < 0) ? _c('td', {
      staticClass: "table-bordered text-center"
    }, [_vm._v(_vm._s(eachItem.whrackstock - eachItem.whcurrentstock))]) : _vm._e(), _vm._v(" "), (eachItem.whrackstock - eachItem.whcurrentstock == 0) ? _c('td', {
      staticClass: "table-bordered text-center"
    }, [_vm._v(_vm._s(eachItem.whrackstock - eachItem.whcurrentstock))]) : _vm._e(), _vm._v(" "), (eachItem.whrackstock - eachItem.whcurrentstock > 0) ? _c('td', {
      staticClass: "table-bordered text-center",
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.viewRackDetails(eachItem.rackid)
        }
      }
    }, [_vm._v(_vm._s(eachItem.whrackstock - eachItem.whcurrentstock))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "table-bordered text-center"
    }, [_vm._v(_vm._s(eachItem.lotno))]), _vm._v(" "), _c('td', {
      staticClass: "table-bordered text-center"
    }, [(eachItem.expirydate) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(eachItem.expirydate)))]) : _c('span')]), _vm._v(" "), _c('td', {
      staticClass: "table-bordered text-center"
    }, [_vm._v("\n                        " + _vm._s(eachItem.subinventory) + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "table-bordered text-center"
    }, [_vm._v(_vm._s(eachItem.merchantname))]), _vm._v(" "), _c('td', {
      staticClass: "table-bordered text-center "
    }, [_vm._v(_vm._s(eachItem.racktype))]), _vm._v(" "), (_vm.isInventoryZone == true) ? _c('td', {
      staticClass: "table-bordered text-center"
    }, [_vm._v(_vm._s(eachItem.zonename))]) : _vm._e()])
  }))])])])]) : _vm._e()])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Stock Allocation TO Order"
    },
    model: {
      value: (_vm.showOrderAllocationRacks),
      callback: function($$v) {
        _vm.showOrderAllocationRacks = $$v
      },
      expression: "showOrderAllocationRacks"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [(_vm.allocationResultData.length > 0) ? _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "font-size": "1.3rem !important"
    }
  }, [_vm._v(_vm._s(_vm.$t('reports.stockAllocatedForProduct')) + ": " + _vm._s(_vm.listData[0].productid) + "/" + _vm._s(_vm.listData[0].eancode) + " ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showOrderAllocationRacks = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('common.orderID')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('pickPendingMoveOrder.table.columns.qty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('reports.csBlockDateandTime')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.allocationResultData), function(allocation) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(allocation.orderid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(allocation.blockqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(allocation.createddate)))])])
  }), _vm._v(" "), (_vm.allocationResultData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e()], 2)])])])])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-381c6348", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-381c6348","hasScoped":true}!./src/views/components/reports/stockenquiry/stockenquiry.component.html
// module id = 1482
// module chunks = 0